import React, { FC } from 'react';
import { SearchAutocompleteFetcher } from './fetcher/SearchAutocompleteFetcher';
import { SearchAutocompleteList } from './SearchAutocompleteList';

type Props = {
  query: string;
  onItemSelected: Function;
  updateQuery: Function;
  manualClose: Function;
  isHistoryMode: boolean;
  isDemoMode: boolean;
  allowEmptyQuery: boolean;
};

export const SearchAutocomplete: FC<Props> = ({
  query,
  onItemSelected,
  updateQuery,
  manualClose,
  isHistoryMode,
  isDemoMode,
  allowEmptyQuery,
}) => (
  <SearchAutocompleteFetcher query={query}>
    {({ items }) => (
      <SearchAutocompleteList
        items={items}
        query={query}
        onItemSelected={onItemSelected}
        updateQuery={updateQuery}
        manualClose={manualClose}
        isDemoMode={isDemoMode}
        isHistoryMode={isHistoryMode}
        allowEmptyQuery={allowEmptyQuery}
      />
    )}
  </SearchAutocompleteFetcher>
);
